import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './DataLossWarning.css';

/**
 * Toont een blokkerende waarschuwing wanneer de app op Railway draait zonder
 * persistent volume. Voorkomt dat gebruikers data invoeren die bij de volgende
 * deploy verloren gaat.
 */
export default function DataLossWarning({ children }) {
  const [dataPersistent, setDataPersistent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const { data } = await api.get('/health');
        if (!cancelled) {
          setDataPersistent(data.dataPersistent !== false);
        }
      } catch (e) {
        if (!cancelled) setDataPersistent(true); // bij fout niet blokkeren
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    check();
    return () => { cancelled = true; };
  }, []);

  const handleRetry = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/health');
      setDataPersistent(data.dataPersistent !== false);
    } catch (e) {
      setDataPersistent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {children}
      {!loading && !dataPersistent && (
    <div className="data-loss-warning-overlay">
      <div className="data-loss-warning-box">
        <h2>Database is niet persistent</h2>
        <p>
          De app draait op Railway <strong>zonder volume</strong>. Alle data (producten, leveranciers, orders, gebruikers) gaat <strong>verloren bij elke deploy</strong>.
        </p>
        <p>Dit mag niet meer gebeuren. Stel een Railway Volume in voordat je verder gaat:</p>
        <ol>
          <li>Railway project → <strong>New</strong> → <strong>Volume</strong></li>
          <li>Koppel het volume aan je service (tab <strong>Volumes</strong>, Mount Path: <code>/data</code>)</li>
          <li>Voeg variable toe: <code>RAILWAY_VOLUME_MOUNT_PATH=/data</code></li>
          <li>Redeploy de service</li>
        </ol>
        <p className="data-loss-warning-doc">Zie <strong>RAILWAY_VOLUME_SETUP.md</strong> in het project voor stap-voor-stap instructies.</p>
        <button type="button" className="data-loss-warning-retry" onClick={handleRetry} disabled={loading}>
          Ik heb het volume ingesteld, controleer opnieuw
        </button>
      </div>
    </div>
      )}
    </>
  );
}
